import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * Shifts dashboard placeholder route.
 * Logged-out users are bounced to the TRITAL ShiftBridge™ login.
 * Logged-in users are forwarded to their main TRITAL Care dashboard
 * which already has the role-aware DashboardHome implementation.
 */
export default function ShiftsDashboard() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-slate-400 text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/shifts/login" replace />;
  return <Navigate to="/dashboard" replace />;
}
